module.exports = __webpack_public_path__ + "img/1_024.e65ef2ff.jpg";